var animate = {
    init: function() {
        animate.start();
    },
    start: function() {
        var _windowHeight = $(window).innerHeight(),
            _st = 0,
            _elePosition = 0,
            _ele = $(".ele-animate");

        function scrollInit() {
            (_st = $(window).scrollTop()),
            (_windowHeight = $(window).innerHeight());

            if (_ele.length > 0) {
                _ele.each(function(index, el) {
                    _elePosition = $(this).offset().top + $(this).outerHeight();
                    if (
                        $(this).offset().top < _windowHeight + _st &&
                        _elePosition > _st
                    ) {
                        if (!$(this).hasClass("in-view")) {
                            $(this).addClass("in-view");
                        }
                    } else {
                        if ($(this).hasClass("in-view")) {
                            $(this).removeClass("in-view");
                        }
                    }
                });
            }
        }

        scrollInit();
        setTimeout(function() {
            scrollInit();
        }, 300);
        setTimeout(function() {
            scrollInit();
        }, 500);
        setTimeout(function() {
            scrollInit();
        }, 800);
        $(window).scroll(function(event) {
            scrollInit();
        });
        $(window).resize(function(event) {
            scrollInit();
        });
    },
};

animate.init();